PegasusTemplate.PaletteController = Em.ObjectController.extend({
  changePalette: function(view){
    PegasusTemplate.stateMachine.send('changePalette', view);
  }
});
